import { call, put, takeLatest } from 'redux-saga/effects';
import { FETCH_ACTIVE_PROGRAMS_DATA_REQUEST, VBC_TAXIDS_REQUEST, FETCH_PAYOUTS_DATA_REQUEST, FETCH_INFLATORS_DATA_REQUEST } from '../actions/actionTypes';
import { fetchActiveProgramsDataError, setActiveProgramsData, fetchVbcTaxIdsFailure, fetchVbcTaxIdsLoading, fetchVbcTaxIdsSuccess, setPayoutsData, fetchPayoutsDataError, setInflatorsData, fetchInflatorsDataError } from '../actions/NetworkManagementActions/ValueBasedContractingActions';
import { getActiveProgramsData } from '@src/middleware/services/NetworkManagement/VBC/ActivePrograms.service';
import { fetchVbcTaxIds } from '@src/middleware/services/NetworkManagement/VBC/VbcFilters.service';
import { getPayoutsData } from '@src/middleware/services/NetworkManagement/VBC/Payouts.service';
import { getInflatorsData } from '@src/middleware/services/NetworkManagement/VBC/Inflators.service';

// The VBC services swallow HTTP errors and resolve null; report that as a failure so loading always settles.
const EMPTY_RESPONSE_ERROR = { statusCode: 500, message: 'No response received' };

export function* fetchVbaData(action: any) {
  try {
    const response = yield call(getActiveProgramsData, action.payload);
    if (response && Array.isArray(response.Data)) {
      response.Data.sort((a, b) => {
        const nameA = a.ProgramName ?? '';
        const nameB = b.ProgramName ?? '';
        return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
      });
    }
    if (response) {
      yield put(setActiveProgramsData(response));
    } else {
      yield put(fetchActiveProgramsDataError(EMPTY_RESPONSE_ERROR));
    }
  } catch (error) {
    console.error('Saga: Error in fetchVbaData:', error);
    yield put(fetchActiveProgramsDataError(error));
  }
}

export function* fetchPayoutsData(action: any) {
  try {
    const response = yield call(getPayoutsData, action.payload);
    if (response) {
      yield put(setPayoutsData(response));
    } else {
      yield put(fetchPayoutsDataError(EMPTY_RESPONSE_ERROR));
    }
  } catch (error) {
    console.error('Saga: Error in fetchPayoutsData:', error);
    yield put(fetchPayoutsDataError(error));
  }
}

export function* fetchInflatorsData(action: any) {
  try {
    const response = yield call(getInflatorsData, action.payload);
    if (response) {
      yield put(setInflatorsData(response));
    } else {
      yield put(fetchInflatorsDataError(EMPTY_RESPONSE_ERROR));
    }
  } catch (error) {
    console.error('Saga: Error in fetchInflatorsData:', error);
    yield put(fetchInflatorsDataError(error));
  }
}

export function* valueBasedContractingSaga() {
  yield takeLatest(FETCH_ACTIVE_PROGRAMS_DATA_REQUEST, fetchVbaData);
  yield takeLatest(FETCH_PAYOUTS_DATA_REQUEST, fetchPayoutsData);
  yield takeLatest(FETCH_INFLATORS_DATA_REQUEST, fetchInflatorsData);
  yield takeLatest(VBC_TAXIDS_REQUEST, fetchVbcTaxIdsSaga);
}

export function* fetchVbcTaxIdsSaga(action: any) {
  try {
    yield put(fetchVbcTaxIdsLoading(true));
  const data = yield call(fetchVbcTaxIds, action.payload);
  yield put(fetchVbcTaxIdsSuccess(data || []));
    yield put(fetchVbcTaxIdsLoading(false));
  } catch (e) {
    yield put(fetchVbcTaxIdsFailure(e));
    yield put(fetchVbcTaxIdsLoading(false));
  }
}

export default [valueBasedContractingSaga]